export enum ServiceViewActionTypes {
  PORTFOLIO_DATA = 'PORTFOLIO_DATA',
}
